import React, { useState } from "react";
import CompanyLogo from "../../common/CompanyLogo";
import mail from "../../assets/sms-tracking.png";
import call from "../../assets/call-calling.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faRobot,
  faUser,
  faEnvelope,
  faMobile,
} from "@fortawesome/free-solid-svg-icons";
import { InquirySolutionEndpoints } from "../../api/endpoints";
import Api_Instance from "../../api/Api_Instance";
import toast from "react-hot-toast";
import Loader from "../../common/loader/Loader";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { emojiPattern, multipleDomainsPattern } from "../../utils/Utils";
import ReCAPTCHA from "react-google-recaptcha";
const Contact = () => {
  const api = Api_Instance.useApi();
  const [loading, setLoading] = useState(false);
  const [captchaToken, setCaptchaToken] = useState("");

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [errors, setErrors] = useState({});

  const validate = (values) => {
    const errors = {};
    const requiredFields = ["name", "email", "phone", "message"];

    requiredFields.forEach((field) => {
      const value = values[field];
      if (
        value === undefined ||
        value === null ||
        (typeof value === "string" && !value.trim()) ||
        (value instanceof File && !value.name)
      ) {
        errors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
      } else if (emojiPattern.test(value)) {
        // errors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} cannot contain  emojis `;
      }
    });

    if (values.email && !/\S+@\S+\.\S+/.test(values.email)) {
      errors.email = "Email address is invalid";
    } else if (multipleDomainsPattern.test(values.email)) {
      errors.email = "Email address is invalid";
    }

    if (values.phone && !/^[6-9]\d{9}$/.test(values.phone)) {
      errors.phone = "Mobile No is invalid";
    }

    if (values.message) {
      if (!/^[A-Za-z\s]+$/.test(values.message)) {
        errors.message = "message should only contain letters and spaces";
      } else if (values.message.length < 10) {
        errors.message = "message must be at least 10 characters";
      } else if (values.message.length > 100) {
        errors.message = "message must be at most 100 characters";
      }
    }
    return errors;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    const fieldError = validate({ [e.target.name]: e.target.value })[
      e.target.name
    ];
    setErrors((prevErrors) => ({
      ...prevErrors,
      [e.target.name]: fieldError,
    }));
  };
  const handleBlur = (e) => {
    const { name, value } = e.target;
    const fieldError = validate({ [name]: value })[name];
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: fieldError,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate(formData);
    setErrors(validationErrors);
    if (!captchaToken) {
      toast.error("Please verify the ReCAPTCHA.");
      return;
    }

    if (Object.keys(validationErrors).length === 0) {
      setLoading(true);
      try {
        const response = await api(
          "POST",
          InquirySolutionEndpoints?.POST_INQUIRY_API,
          formData
        );
        toast.success(response?.data?.message);
        setCaptchaToken('')
        setFormData({
          name: "",
          email: "",
          phone: "",
          message: "",
        });
      } catch (error) {
        console.log(error);
      }
      finally {
        setLoading(false);
      }
    }
  };
  return (
    <div className="w-full p-4 max-w-[1250px] mb-5 mx-auto">
      <CompanyLogo title={"Contact Us"} subtitle={"Contact"} />
      <h1 className="text-3xl font-semibold w-full pb-2">
        Contact Us
      </h1>
      <hr className="mb-2" />
      <div className="flex md:flex-row flex-col justify-between items-start gap-4">
        <div className="space-y-4">
          <div>
            <h2 className="text-[#222222] font-medium text-xl">
              Get In touch with us
            </h2>
            <p className="text-subtext_color text-sm font-normal">
              Looking to kickstart your entrepreneurial journey or grow your franchise business? We're here to help! Connect with us to explore franchise opportunities <br /> startup solutions, and expert guidance to scale your business to new heights.
            </p>
          </div>
          <div className="flex justify-start items-center gap-3">
            <div className="w-10 h-10 bg-primaryColor p-2">
              <img src={mail} alt="Mail" />
            </div>
            <div>
              <h3 className="text-[#222222] font-semibold">Email</h3>
              <p className="text-subtext_color text-sm">
                sales@frachisebx.com
              </p>
            </div>
          </div>
          <div className="flex justify-start items-center gap-3">
            <div className="w-10 h-10 bg-primaryColor p-2">
              <img src={call} alt="call" />
            </div>
            <div>
              <h3 className="text-[#222222] font-semibold">Contact</h3>
              <p className="text-subtext_color text-sm">9530002568</p>
            </div>
          </div>
        </div>
        <div className="bg-card_bg_color xl:p-6 lg:p-6 md:p-6 p-3 rounded-md mt-1 md:mt-0 border">
          <h2 className="text-xl text-center font-semibold mb-4">
            Get solutions to all your inquiries here!
          </h2>
          <form
            onSubmit={handleSubmit}
            className="space-y-4 bg-card_bg_color rounded-md"
          >
            <div className="flex flex-col items-center ">
              <div className="relative w-full xl:p-3 lg:p-3 md:p-3 p-1">
                <FontAwesomeIcon
                  icon={faUser}
                  className="input-icon absolute left-[14px] bg-white mt-3 mr-5"
                />
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Name"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={formData?.name}
                  className="border border-[#D9D9D9] rounded-md mt-1 block py-2 px-[35px] w-full "
                  maxLength={30}
                />
                {errors.name && (
                  <p className="text-star_color text-sm">{errors.name}</p>
                )}
              </div>
              <div className="relative w-full xl:p-3 lg:p-3 md:p-3 p-1">
                <FontAwesomeIcon
                  icon={faEnvelope}
                  className="input-icon absolute left-[14px] mt-3 mr-5"
                />
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Email"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={formData?.email}
                  maxLength={25}
                  className="border border-[#D9D9D9] rounded-md mt-1 block py-2 px-[35px] w-full"
                />
                {errors.email && (
                  <p className="text-star_color text-sm">{errors.email}</p>
                )}
              </div>
              <div className="relative w-full xl:p-3 lg:p-3 md:p-3 p-1">
                <FontAwesomeIcon
                  icon={faMobile}
                  className="input-icon absolute left-[14px] mt-3 mr-5"
                />
                <input
                  type="mobile"
                  id="mobile"
                  name="phone"
                  placeholder="mobile"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={formData?.phone}
                  className="border border-[#D9D9D9] rounded-md mt-1 py-2 px-[35px] block w-full"
                />
                {errors.phone && (
                  <p className="text-star_color text-sm">{errors.phone}</p>
                )}
              </div>

              <div className="relative w-full xl:p-3 lg:p-3 md:p-3 p-1">
                <textarea
                  className="border border-[#D9D9D9] rounded-md mt-1 block p-3 w-full h-20"
                  placeholder="Message"
                  id="Message"
                  name="message"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={formData?.message}
                ></textarea>
                {errors.message && (
                  <p className="text-star_color text-sm">{errors.message}</p>
                )}
              </div>
              <div className="w-full flex items-center mt-3 pl-3">
           
                <label
                  htmlFor="captcha"
                  className="ml-2 flex items-center text-gray-700 text-sm cursor-pointer"
                >
                  <ReCAPTCHA
                    // sitekey= "6Ld_Ip4qAAAAAFzyb5JeIfCdiZxdUVNgOGB-lJr1"  // Your public site key main server
                    sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
                    onChange={(token) => setCaptchaToken(token)}
                  />
                </label>
              </div>
            </div>
            <div className="xl:pl-10 lg:pl-3 pl-0  mx-auto text-center flex items-center justify-between ">
              <button
                type="submit"
                disabled={loading}
                className="border-2 border-[#0097c5] bg-[#0097c5] flex items-center justify-center  text-white rounded-md border-gray-600 mt-4 text-center text-base text-gray-800 py-2  xl:w-60 lg:w-60md:w-60 w-28  cursor-pointer [transition:all_.15s_ease-in-out] hover:[box-shadow:0_0_10px_0_#0098c6_inset,_0_0_20px_2px_#0096c48c]"
              >
                {loading ? (
                  <Loader />
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
